export default "__VITE_ASSET__BP1UOe8v__"